import React from "react";
import { Modal } from "antd";

const ApprovedModal = ({
  isApprovedModalVisible,
  handleApprovedCancel,
  handleApprovedOk,
  data,
}) => {
  return (
    <>
      <Modal
        title="Approved"
        footer={null}
        closable
        open={isApprovedModalVisible}
        onOk={handleApprovedOk}
        onCancel={handleApprovedCancel}
        width={500}
        style={{
          top: 200,
        }}
      >
        <div className="row">
          <div className="form-group">
            <label
              htmlFor="exampleFormControlTextarea1 fw-bold"
              className="fs_14"
            >
              Are you sure you want to approved this Teacher
            </label>
          </div>
          <div className="text-right">
            <button
              onClick={handleApprovedCancel}
              className="btn btn_outlined fs_12 btn-sm text-danger px-3 py-1 mr-2"
            >
              No
            </button>
            <button
              onClick={handleApprovedOk}
              type="submit"
              className="btn btn_contained_black fs_12 btn-sm text-white px-3 py-1"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ApprovedModal;
